import { Body1, Body2 } from '@xo-union/tk-ui-typography';
import React from 'react';

import { Room } from '../../contexts/TransientRooms';
import styles from './room.scss';
import AddToWebsite from '../../../../components/TansientRoomRailCard/AddToWebsite';

interface Props {
  room: Room;
  onClick: (room: Room) => void;
}

const TransientRoomComponent: React.FC<Props> = ({ room, onClick }) => {
  const { propertyId, imagePath, propertyName, price } = room;
  return (
    <div className={styles.room}>
      <Body1 bold className={`${styles.webkitBox} ${styles.name}`}>
        {propertyName}
      </Body1>
      <button className={styles.roomImage} onClick={(): void => onClick(room)}>
        {imagePath && <img className={styles.img} src={imagePath} alt={propertyName} />}
      </button>
      <div className={styles.priceContainer}>
        <Body2 className={styles.price}>{`${price > 0 ? `from $${price.toFixed(2).toLocaleString()}` : ''}`}</Body2>

        <AddToWebsite onClick={(): void => onClick(room)} propertyId={propertyId} />
      </div>
    </div>
  );
};

export default TransientRoomComponent;
